import { Component } from 'react'
import {
    getUrlParameter,
    isWebView,
} from './admin/actions'
import {
    RESPONSIVE_WIDTH,
    S_SPORTNECT,
    S_SPORTUJ_V_OSTRAVE,
    S_SPORTUJ_V_CHEBU,
    RESPONSIVE_LG_WIDTH,
    ADMIN_PAGES,
} from './consts'

/**
 * Load configurations into config component
 */
export default class Configurator extends Component {
    config = {}
    axios = window.axios

    constructor(props) {
        super(props)

        //@ToDo: Global state is very difficult to test - move it to single place and pass it rather as a dependency then parent.
        const globalConfiguration = window?.APP_CONFIG?.REACT_APP_AUTH_ROUTES

        this.config = {
            ...window.APP_CONFIG,
            windowWidth: window.innerWidth || window.outerWidth,
            scrollY: window.scrollY,
            locationSearch: window.location.search,
            locationHash: window.location.hash,
            navigator: window.navigator,
            loginRoute: `/${globalConfiguration?.login}`,
            signupRoute: `/${globalConfiguration?.signup}`,
            forgottenPasswordRoute: `/${globalConfiguration?.forgottenPassword}`,
            signpostLoginRoute: `/${globalConfiguration?.signpostLoginRoute}`,
        }
    }

    /**
     * Check if user is coming from SFN subpage
     *
     * @return {boolean}
     */
    isSfnType = () => getUrlParameter('type') === 'fromSfn'

    /**
     * Check if user is on dashboard (admin) page
     *
     * @return {boolean}
     */
    isAdminPage = () => {
        for (let i = 0; i < ADMIN_PAGES.length; i++) {
            if (window.location.href.includes(ADMIN_PAGES[i])) {
                return true
            }
        }
        return false
    }

    /**
     * Check if user profile is from SFN
     *
     * @param {Object} user
     * @return {boolean}
     */
    isSfnProfile = user => !!user?.sfnData?.data?.sfn

    /**
     * Get current window scroll Y
     *
     * @return {int}
     */
    getScrollY = () => window.scrollY

    /**
     * Get current window scroll X
     *
     * @return {int}
     */
    getScrollX = () => window.scrollX

    /**
     * Get current scroll offset Y
     *
     * @return {int}
     */
    getOffsetY = () => window.innerHeight + window.scrollY

    /**
     * Get document height
     *
     * @return {number}
     */
    getDocHeight = () => Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
    )

    /**
     * Get height of footer element
     *
     * @return {number}
     */
    getFooterHeight = () => document.getElementsByTagName('footer')?.[0]?.offsetHeight || 0

    /**
     * Check if scrolling is on end of page
     *
     * @return {boolean}
     */
    isEndOfPage = () => this.getOffsetY() >= this.getDocHeight()

    /**
     * Check if scrolling is on bottom page - page offset
     *
     * @param {number} offsetHeight
     * @return {boolean}
     */
    isEndOfPageOffsetted = (offsetHeight = 0) => this.getOffsetY() >= (this.getDocHeight() - offsetHeight)

    /**
     * Add window listener
     *
     * @param {string} name
     * @param {function} func
     * @return {function}
     */
    addListener = (name, func) => window.addEventListener(name, e => func(e))

    /**
     * Remove window listener
     *
     * @param {string} name
     * @param {function}func
     * @return {function}
     */
    removeListener = (name, func) => window.removeEventListener(name, e => func(e))

    /**
     * Add listener for scroll page
     *
     * @param {function} func
     * @return {function}
     */
    addScrollListener = func => this.addListener('scroll', () => func())

    /**
     * Remove listener for scroll page
     *
     * @param {function} func
     * @return {function}
     */
    removeScrollListener = func => this.removeListener('scroll', () => func())

    /**
     * Reload page
     *
     * @return {*}
     */
    reload = () => window.location.reload()

    /**
     * Scroll to top of page
     *
     * @return {*}
     */
    scrollTop = () => window.scrollTo(0, 0)

    /**
     * Return true if is Sportnect
     * @returns {boolean}
     */
    isSportnectSystem = () => this.config.REACT_APP_SYSTEM === S_SPORTNECT

    /**
     * Return true if is Ostrava
     * @returns {boolean}
     */
    isOstravaSystem = () => this.config.REACT_APP_SYSTEM === S_SPORTUJ_V_OSTRAVE

    /**
     * Return true if is Cheb
     * @returns {boolean}
     */
    isChebSystem = () => this.config.REACT_APP_SYSTEM === S_SPORTUJ_V_CHEBU

    /**
     * Is window width smaller than responsive width?
     *
     * @return {boolean}
     */
    isResponsive = () => window.innerWidth < RESPONSIVE_WIDTH

    /**
     * Is window width smaller than notebook device?
     *
     * @return {boolean}
     */
    isMobileDevice = () => window.innerWidth < RESPONSIVE_LG_WIDTH

    /**
     * Check if is rendered responsive menu or not
     *
     * @return {boolean}
     */
    isResponsiveMenu = () => window.innerWidth < 1200

    /**
     * Check if can show Facebook auth in webview
     *
     * @return {boolean}
     */
    showAuthFacebook = () => (!isWebView() || (isWebView() && this.config.REACT_APP_WEBVIEW_AUTH_FACEBOOK))

}
